var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplyGroupCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49822 12.8254C7.49822 13.068 7.40544 13.3013 7.23889 13.4777C6.87864 13.8591 6.27737 13.8763 5.89593 13.5161L0.787212 8.69115C0.767662 8.67233 0.767662 8.67233 0.748842 8.65278C0.388591 8.27134 0.40577 7.67008 0.787212 7.30983L5.89593 2.48492C6.07228 2.31837 6.30566 2.22559 6.54822 2.22559C7.07289 2.22559 7.49822 2.65092 7.49822 3.17559V5.09962C11.7162 5.92041 14.15 8.67243 15.2506 12.8819L15.3786 13.4393C15.4525 13.7607 15.3337 14.0958 15.074 14.299C14.7043 14.5883 14.1701 14.5231 13.8808 14.1534L13.5198 13.6907C12.0085 11.9366 10.1866 11.0876 7.49822 10.959V12.8254ZM6.64233 6.47631L5.99822 6.38445V4.45155L2.24053 8.00049L5.99822 11.5494V9.4416H6.74822C9.39699 9.4416 11.431 10.0121 13.1141 11.2661C11.9212 8.58103 9.87179 6.93688 6.64233 6.47631Z",
    fill: "#AC92ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyGroupCall);
export default __webpack_public_path__ + "static/media/reply_group_call.199f85832d978d3cac87834ff05d9efc.svg";
export { ForwardRef as ReactComponent };